import React from 'react';
import { setCurrentView } from 'core/utils';
import { CloseOutExitViewStore } from 'modules/order/stores';
import { CloseOutExitTemplate } from 'themes/modules/order/pages';

@setCurrentView(rootStore => new CloseOutExitViewStore(rootStore), 'closeOutExitViewStore')
class CloseOutExit extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <CloseOutExitTemplate {...this.props} />;
	}
}

export default CloseOutExit;
